import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// /auth/callback/x — X OAuth callback. The browser hits this route with
// `code` and `state` query params. We forward the exchange to our Pages
// Function which handles the PKCE-verified token swap, runs the
// consolidation function, mints a Supabase session and sets the cookie.
export function XCallbackRoute() {
	const [params] = useSearchParams();
	const navigate = useNavigate();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const code = params.get("code");
		const state = params.get("state");
		if (!code || !state) {
			setError("Missing code/state from X");
			return;
		}

		const next = sessionStorage.getItem("hf_next") ?? "/";
		sessionStorage.removeItem("hf_next");

		void (async () => {
			try {
				const res = await fetch(
					`/api/auth/x/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
					{ credentials: "include" },
				);
				if (!res.ok) {
					const body = await res.text();
					throw new Error(body || `HTTP ${res.status}`);
				}
				void navigate(next, { replace: true });
			} catch (err) {
				setError(err instanceof Error ? err.message : "X callback failed");
			}
		})();
	}, [params, navigate]);

	return (
		<div className="flex min-h-screen items-center justify-center px-4">
			{error ? (
				<div className="max-w-md text-center text-sm text-[var(--color-danger)]">
					<p className="font-semibold">X sign-in failed</p>
					<p className="mt-2 text-[var(--color-muted)]">{error}</p>
					<button
						onClick={() => navigate("/auth/login", { replace: true })}
						className="mt-4 rounded-md border border-[var(--color-border)] px-3 py-1.5 text-sm hover:border-[var(--color-accent)]"
					>
						Back to sign in
					</button>
				</div>
			) : (
				<p className="text-[var(--color-muted)]">Finishing sign-in…</p>
			)}
		</div>
	);
}
